/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_StartInputs */

const en_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a project`)
};

const ar_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ مشروعًا`)
};

const bn_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি প্রজেক্ট শুরু করুন`)
};

const de_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt starten`)
};

const es_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar un proyecto`)
};

const fr_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer un projet`)
};

const pt_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar um projeto`)
};

const zh_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动一个项目`)
};

const tr_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir proje başlatın`)
};

const ru_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать проект`)
};

const pl_cta_start = /** @type {(inputs: Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij projekt`)
};

/**
* | output |
* | --- |
* | "Start a project" |
*
* @param {Cta_StartInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_start = /** @type {((inputs?: Cta_StartInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_StartInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_start(inputs)
	if (locale === "bn") return bn_cta_start(inputs)
	if (locale === "de") return de_cta_start(inputs)
	if (locale === "es") return es_cta_start(inputs)
	if (locale === "fr") return fr_cta_start(inputs)
	if (locale === "pt") return pt_cta_start(inputs)
	if (locale === "zh") return zh_cta_start(inputs)
	if (locale === "tr") return tr_cta_start(inputs)
	if (locale === "ru") return ru_cta_start(inputs)
	if (locale === "pl") return pl_cta_start(inputs)
	return en_cta_start(inputs)
});